import { Box, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '@lingui/macro';
import { useAppDispatch, useAppSelector } from '../hooks';
import appRoutes from '../utils/routes';
import StyledButton from '../components/StyledButton';
import api from '../api';
import lodash from 'lodash';
import userSlice from '../store/userSlice';
import SecondaryHeader from '../components/SecondaryHeader';

const PhoneConfirmationScreen: React.FC = () => {
    const dispatch = useAppDispatch();
    const phoneNumber = useAppSelector(state => state.user.phoneNumber)
    const userName = useAppSelector(state => state.user.name)
    const navigate = useNavigate()
    const [code, setCode] = useState<string | undefined>()
    const [canSendCode, setCanSendCode] = useState<boolean>(true)
    const [remainingSeconds, setRemainingSeconds] = useState<string>()
    let updaterId: number | NodeJS.Timer;

    const isCodeValid = code && code.length === 4;

    const onConfirmClick = async () => {
        if (phoneNumber && code) {
            await api.checkConfirmationCode(phoneNumber, code)
            const userInfo = await api.getUserInfo()
            dispatch(userSlice.actions.setUserId(userInfo._id!))
            dispatch(userSlice.actions.changeUserVerification(true))
            navigate(appRoutes.checkout)
        }
    }

    function sendCode() {
        canSendCode && userName && phoneNumber && api.requestConfirmationCode(userName, phoneNumber)
        setCanSendCode(false)
        let antiSpamSeconds = 30;
        updaterId = setInterval(function () {
            antiSpamSeconds--;
            setRemainingSeconds(String(antiSpamSeconds))
            if (antiSpamSeconds === 0) {
                setRemainingSeconds('')
                clearInterval(updaterId);
                setCanSendCode(true)
            }

        }, 1000);
    }

    useEffect(() => {
        return () => clearInterval(updaterId); // to clean up on unmount
    }, []);

    useEffect(() => {
        sendCode()
    }, [phoneNumber, userName])

    return <Box display={'flex'} flexDirection={'column'} sx={{ height: 'calc(100vh - 32px)' }}>
        <SecondaryHeader />
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} py={'16px'}>
            <Typography variant='h4'>{t`Verify code`}</Typography>
        </Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} pb={'36px'}>
            <Typography>
                {t`We just sent a 4-digit verification code to ${phoneNumber}. Enter the code in the box below to continue.`}
            </Typography>
        </Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} pb={'24px'}>
            <TextField
                type={'phone'}
                label="Code"
                rows={1}
                value={code}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setCode((event.target as HTMLInputElement).value);
                }} />
        </Box>
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <Box>
                <Typography>{t`Didn’t receive a code?`}</Typography>
            </Box>
            <StyledButton disabled={!canSendCode} size={'small'} variant='text' color='secondary' onClick={sendCode}>
                <Typography>{canSendCode ? t`Resend Code` : t`Resend Code in: ${remainingSeconds}`}</Typography>
            </StyledButton>
        </Box>
        <Box display={'flex'} flexGrow={1} alignItems={'end'}>
            <StyledButton disabled={!isCodeValid} variant='contained' sx={{ mb: '8px' }} fullWidth onClick={onConfirmClick}>
                <Typography>{t`Continue`}</Typography>
            </StyledButton>
        </Box>
    </Box>
}

export default PhoneConfirmationScreen;